/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Final_End_Cycle_InfoInputs */

const en_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription will end, and you will not be charged on the next billing period.`)
};

const id_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan Anda akan berakhir, dan Anda tidak akan dikenakan biaya pada periode penagihan berikutnya.`)
};

const ms_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan anda akan tamat, dan anda tidak akan dicaj pada tempoh bil yang seterusnya.`)
};

const ca_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La teva subscripció finalitzarà i no se't cobrarà en el proper període de facturació.`)
};

const cs_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše předplatné skončí a při dalším fakturačním období vám nebude účtováno.`)
};

const da_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit abonnement ophører, og du vil ikke blive opkrævet i næste faktureringsperiode.`)
};

const de_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement endet und Sie werden im nächsten Abrechnungszeitraum nicht belastet.`)
};

const et_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie tellimus lõpeb ja teilt ei võeta tasu järgmise arveldusperioodi jooksul.`)
};

const es_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción terminará y no se te cobrará en el próximo período de facturación.`)
};

const fr_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement prendra fin et aucun montant ne sera prélevé pour la prochaine période.`)
};

const hr_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša pretplata će završiti i nećete biti terećeni u sljedećem obračunskom razdoblju.`)
};

const it_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento sarà cancellato e non ti verrà addebitato il prossimo ciclo di fatturazione.`)
};

const lv_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu abonements beigsies, un jums netiks iekasēta maksa nākamajā norēķinu periodā.`)
};

const lt_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų prenumerata baigsis ir kitame mokėjimo laikotarpyje nebus apmokestinama.`)
};

const hu_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az előfizetése lejár, és a következő számlázási időszakban nem lesz terhelve.`)
};

const nl_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je abonnement wordt beëindigd en je wordt niet gefactureerd in de volgende factureringsperiode.`)
};

const nb_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementet ditt sies opp, og du vil ikke bli belastet i neste betalingsperiode.`)
};

const pl_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja zostanie zakończona, a opłata nie zostanie naliczona w następnym okresie rozliczeniowym.`)
};

const pt_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura terminará, e você não será cobrado no próximo período de faturamento.`)
};

const ro_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonamentul dvs. va expira și nu veți fi taxat în următoarea perioadă de facturare.`)
};

const sk_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše predplatné skončí a v nasledujúcom fakturačnom období nebudete účtovaný.`)
};

const sl_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša naročnina se bo končala in v naslednjem obračunskem obdobju ne boste prejeli obračuna.`)
};

const fi_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilauksesi päättyy, eikä sinua veloiteta seuraavalla laskutuskaudella.`)
};

const sv_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt abonnemang kommer att avslutas, och du kommer inte att debiteras för nästa faktureringsperiod.`)
};

const vi_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói đăng ký của bạn sẽ kết thúc, và bạn sẽ không bị tính phí trong kỳ thanh toán tiếp theo.`)
};

const tr_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliğiniz sona erecek ve bir sonraki fatura döneminde ücret alınmayacak.`)
};

const el_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η συνδρομή σας θα λήξει και δεν θα χρεωθείτε στην επόμενη περίοδο χρέωσης.`)
};

const bg_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонаментът ви ще приключи и няма да бъдете таксувани за следващия биллингов период.`)
};

const ru_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка закончится, и платежи не будут списаны в следующем расчетном периоде.`)
};

const sr_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша претплата ће се завршити и нећете бити наплаћени у следећем обрачунском периоду.`)
};

const uk_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша підписка закінчиться, і з вас не буде стягнута плата в наступний платіжний період.`)
};

const ka_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი გამოწერა დასრულდება და იმ მომდევნო საგადასახადო პერიოდში აღარ დაგავალიანებული.`)
};

const hi_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी सदस्यता समाप्त हो जाएगी, और आपको अगले बिलिंग अवधि में शुल्क नहीं लिया जाएगा।`)
};

const th_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสมัครของคุณจะสิ้นสุดลง และคุณจะไม่ถูกเรียกเก็บค่าใช้จ่ายในรอบบิลถัดไป`)
};

const ko_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독이 종료되며, 다음 청구 기간에는 요금이 청구되지 않습니다.`)
};

const zh_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的订阅即将结束，您在下一个计费周期将不会被收取费用。`)
};

const zh_tw_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的訂閱服務即將結束，下個計費週期將不會向您收取費用。`)
};

const ja_final_end_cycle_info = /** @type {(inputs: Final_End_Cycle_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションは終了し、次の請求期間には料金は発生しません。`)
};

/**
* | output |
* | --- |
* | "Your subscription will end, and you will not be charged on the next billing period." |
*
* @param {Final_End_Cycle_InfoInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const final_end_cycle_info = /** @type {((inputs?: Final_End_Cycle_InfoInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Final_End_Cycle_InfoInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_final_end_cycle_info(inputs)
	if (locale === "ms") return ms_final_end_cycle_info(inputs)
	if (locale === "ca") return ca_final_end_cycle_info(inputs)
	if (locale === "cs") return cs_final_end_cycle_info(inputs)
	if (locale === "da") return da_final_end_cycle_info(inputs)
	if (locale === "de") return de_final_end_cycle_info(inputs)
	if (locale === "et") return et_final_end_cycle_info(inputs)
	if (locale === "es") return es_final_end_cycle_info(inputs)
	if (locale === "fr") return fr_final_end_cycle_info(inputs)
	if (locale === "hr") return hr_final_end_cycle_info(inputs)
	if (locale === "it") return it_final_end_cycle_info(inputs)
	if (locale === "lv") return lv_final_end_cycle_info(inputs)
	if (locale === "lt") return lt_final_end_cycle_info(inputs)
	if (locale === "hu") return hu_final_end_cycle_info(inputs)
	if (locale === "nl") return nl_final_end_cycle_info(inputs)
	if (locale === "nb") return nb_final_end_cycle_info(inputs)
	if (locale === "pl") return pl_final_end_cycle_info(inputs)
	if (locale === "pt") return pt_final_end_cycle_info(inputs)
	if (locale === "ro") return ro_final_end_cycle_info(inputs)
	if (locale === "sk") return sk_final_end_cycle_info(inputs)
	if (locale === "sl") return sl_final_end_cycle_info(inputs)
	if (locale === "fi") return fi_final_end_cycle_info(inputs)
	if (locale === "sv") return sv_final_end_cycle_info(inputs)
	if (locale === "vi") return vi_final_end_cycle_info(inputs)
	if (locale === "tr") return tr_final_end_cycle_info(inputs)
	if (locale === "el") return el_final_end_cycle_info(inputs)
	if (locale === "bg") return bg_final_end_cycle_info(inputs)
	if (locale === "ru") return ru_final_end_cycle_info(inputs)
	if (locale === "sr") return sr_final_end_cycle_info(inputs)
	if (locale === "uk") return uk_final_end_cycle_info(inputs)
	if (locale === "ka") return ka_final_end_cycle_info(inputs)
	if (locale === "hi") return hi_final_end_cycle_info(inputs)
	if (locale === "th") return th_final_end_cycle_info(inputs)
	if (locale === "ko") return ko_final_end_cycle_info(inputs)
	if (locale === "zh") return zh_final_end_cycle_info(inputs)
	if (locale === "zh-tw") return zh_tw_final_end_cycle_info(inputs)
	if (locale === "ja") return ja_final_end_cycle_info(inputs)
	return en_final_end_cycle_info(inputs)
});